import React, { useState } from "react";
import ValueImg from "../../../../assets/ourValue.png"; // change to your image
import Team1 from "../../../../assets/TeamMembers1.jpg";
import Team2 from "../../../../assets/TeamMembers2.jpg";
import Team3 from "../../../../assets/TeamMembers3.png";
import Team4 from "../../../../assets/TeamMembers4.jpg";
import Team5 from "../../../../assets/TeamMembers5.jpg";
import FacebookIcon from "../../../../assets/Facebook.png";
import LinkedInIcon from "../../../../assets/LinkedIn.png";
import TwitterIcon from "../../../../assets/Twitter.png";


const team = [
  {
    name: "Zane Sorell",
    role: "CEO",
    desc: "enjoys adventurous travel, seeks new cultures and offbeat destinations",
    img: Team1,
    facebook: FacebookIcon,
    linkedin: LinkedInIcon,
    twitter: TwitterIcon,
  },
  {
    name: "Maya Mathy",
    role: "Founder",
    desc: "pop music lover, seeks joy and exciting pop concerts",
    img: Team2,
    facebook: FacebookIcon,
    linkedin: LinkedInIcon,
    twitter: TwitterIcon,
  },
  {
    name: "Alexis Jensen",
    role: "CTO",
    desc: "bookworm, creative software developer with precision",
    img: Team3,
    facebook: FacebookIcon,
    linkedin: LinkedInIcon,
    twitter: TwitterIcon,
  },
  {
    name: "Keira Battye",
    role: "Product Designer",
    desc: "creative painter capturing beauty with imaginative artwork",
    img: Team4,
    facebook: FacebookIcon,
    linkedin: LinkedInIcon,
    twitter: TwitterIcon,
  },
  {
    name: "Dominic Game",
    role: "3D Artist",
    desc: "football enthusiast, enjoys movie nights with friends",
    img: Team5,
    facebook: FacebookIcon,
    linkedin: LinkedInIcon,
    twitter: TwitterIcon,
  },
];

const OurValuesandMeetOurTeam = () => {

  const [isShowMeetOurMembers, setIsShowMeetOurMembers] = useState(false);
  return (
    <div className="w-full font-[Lexend] pt-4">

      {/* ---------------- OUR VALUE SECTION ---------------- */}
      <section className="w-full bg-white py-20 px-6">
        <div className="max-w-7xl mx-auto flex flex-col items-center gap-10">

          {/* CENTERED HEADING */}
          <h2 className="text-3xl font-semibold text-center text-[#000] sm:text-[35px] text-[46px]">
            our <span className="text-[#fcb900] sm:text-[35px] text-[46px]">value</span>
          </h2>

          {/* CONTENT SECTION (IMAGE + TEXT) */}
          <div className="flex flex-col md:flex-row items-center gap-10">

            {/* LEFT IMAGE */}
            <div className="md:w-1/2 flex justify-center">
              <img
                src={ValueImg}
                alt="value"
                className="rounded-sm w-full max-w-[700px] mb-6 ml-37.8 md:h-[400px]"
              />
            </div>

            {/* RIGHT TEXT */}
            <div className="md:w-1/2 text-center md:text-left text-[#363636]">
              <p className="font-[Lexend] sm:text-[16px] text-[20px] sm:leading-[30px] leading-[35px] font-[400] lowercase text-[#363636] tracking-[0.05em]">
                be
                <span className="inline-block scale-x-[-1] tracking-[0px]">
                  e
                </span>
                mz delivers innovative high-tech solutions at an affordable cost to
                all within the restaurant and retail business space. grow your
                operations with ease and deepen your customer connections giving
                everyone a vip experience, always. while our no commission promise and
                low fixed fees ensures your revenue remains yours and your profits
                stay in your pocket.
              </p>

            </div>
          </div>
        </div>
      </section>


      {/* ---------------- MEET OUR TEAM ---------------- */}
      {isShowMeetOurMembers &&
        <section className="w-full bg-white py-16 pb-18 md:py-1 px-4 sm:px-6 text-center">

          {/* TITLE */}
          <h2 className="text-5xl font-semibold text-[#111]">
            meet our <span className="text-[#fcb900]">team members</span>
          </h2>
          <p className="text-[#6b6b6b] mt-6 mb-16 text-sm md:text-base">
            complete the form below to send us a message. our support team will promptly respond to your request.
          </p>

          {/* TEAM CARDS */}
          <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10 mt-14">

            {team.map((person, index) => (
              <div key={index} className="text-center">
                <img
                  src={person.img}
                  alt={person.name}
                  className="w-80 aspect-square rounded-full object-cover mx-auto hover:scale-105 duration-700"


                />
                <h3 className="mt-6 font-semibold text-[17px]">{person.name}</h3>
                <p className="text-[#7c5dfa] text-sm lowercase">{person.role}</p>
                <p className="text-[#606060] text-xs mt-4 px-5 leading-relaxed lowercase">{person.desc}</p>

                {/* Social icons (optional) */}
                <div className="flex justify-center gap-4 mt-4 items-center mb-8">
                  <img
                    src={person.facebook}
                    alt="facebook"
                    className="w-5 h-5 cursor-pointer hover:scale-110 duration-200"
                  />
                  <img
                    src={person.linkedin}
                    alt="linkedin"
                    className="w-5 h-5 cursor-pointer hover:scale-110 duration-200"
                  />
                  <img
                    src={person.twitter}
                    alt="twitter"
                    className="w-5 h-5 cursor-pointer hover:scale-110 duration-200"
                  />
                </div>
              </div>
            ))}

          </div>
        </section>
      }

    </div>
  );
};

export default OurValuesandMeetOurTeam;
